import { render, staticRenderFns } from "./IconCheckbox.vue?vue&type=template&id=4d46c6aa&scoped=true&"
import script from "./IconCheckbox.vue?vue&type=script&lang=js&"
export * from "./IconCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./IconCheckbox.vue?vue&type=style&index=0&id=4d46c6aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46c6aa",
  null
  
)

export default component.exports